import { render, staticRenderFns } from "./Speakers.vue?vue&type=template&id=9fb3420a&"
import script from "./Speakers.vue?vue&type=script&lang=js&"
export * from "./Speakers.vue?vue&type=script&lang=js&"
import style0 from "./Speakers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports